export const apiList = {
    // 'getAllevents' : 'api/Calendar/GetCalenderById',
    // 'meetingRequest':'api/Calendar/MeetingRequest',

    'getFreeTime' : '/freetime',
    'meetingRequest':'/calendarevent',
    'getEvents':'/calendarevent/withoutfreetime',
    
}